if (!customElements.get('product-form-component')) {
  customElements.define(
    'product-form-component',
    class ProductForm extends HTMLElement {
      constructor() {
        super();
        this.init();
      }

      init() {
        this.form = this.querySelector('form');
        if (!this.form) return;
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-drawer');
        this.submitButton = this.form?.querySelector('.add-to-cart-button');
        this.submitButtonText = this.submitButton ? this.submitButton.querySelector('span') : null;
        this.checkbox = this.form?.querySelector('[id^="agree_condition-"]');
        this.buyItNowButton = this.form?.querySelector('.shopify-payment-button');

        if (document.querySelector('cart-drawer') && this.submitButton) {
          this.submitButton.setAttribute('aria-haspopup', 'dialog');
        }

        this.hideErrors = this.dataset.hideErrors === 'true';
        this.initAgreeCondition();
        this.setupErrorSync();
      }

      setupErrorSync() {
        try {
          const productInfo = this.closest('product-info');
          const sectionId = productInfo?.dataset.section || productInfo?.dataset.originalSection;
          if (!sectionId) return;

          const stickyATC = document.querySelector(`sticky-atc[data-sticky-section-id="${sectionId}"]`);
          if (!stickyATC) return;

          const mainErrorWrapper = this.querySelector('.product-form__error-message-wrapper');
          const stickyErrorWrapper = stickyATC.querySelector('.product-form__error-message-wrapper');
          if (!mainErrorWrapper || !stickyErrorWrapper) return;

          const syncFromMain = () => {
            const isVisible = !mainErrorWrapper.hasAttribute('hidden');
            const errorMessage = mainErrorWrapper.querySelector('.product-form__error-message')?.textContent;
            stickyErrorWrapper.toggleAttribute('hidden', !isVisible || !errorMessage);
            if (isVisible && errorMessage) {
              const stickyErrorMessage = stickyErrorWrapper.querySelector('.product-form__error-message');
              if (stickyErrorMessage) stickyErrorMessage.textContent = errorMessage;
            }
          };

          syncFromMain();
          this._errorObserver = new MutationObserver(syncFromMain);
          this._errorObserver.observe(mainErrorWrapper, {
            attributes: true,
            attributeFilter: ['hidden'],
            childList: true,
            subtree: true,
          });

          this.cartErrorUnsubscriber = subscribe(PUB_SUB_EVENTS.cartError, () => {
            syncFromMain();
          });
        } catch (e) {}
      }

      initAgreeCondition() {
        if (!this.checkbox || !this.buyItNowButton) return;
        this.buyItNowButton.classList.add('disabled');
        this.checkbox.addEventListener('change', () => {
          this.buyItNowButton.classList.toggle('disabled', !this.checkbox.checked);
        });
        this.form.addEventListener('submit', (e) => {
          if (!this.checkbox.checked) e.preventDefault();
        });
      }

      // Reusable notification logic
      showNotification(message) {
        const existing = document.querySelector('.cart-notification-popup');
        if (existing) existing.remove();

        const toast = document.createElement('div');
        toast.className = 'cart-notification-popup';
        toast.innerText = message;
        
        Object.assign(toast.style, {
          position: 'fixed',
          bottom: '40px',
          left: '0px',
          right: '0px',
          margin: '0 auto',
          width: 'max-content',
          backgroundColor: '#000',
          color: '#fff',
          padding: '12px 24px',
          borderRadius: '4px',
          zIndex: '99999',
          opacity: '0',
          transition: 'all 0.3s ease',
          transform: 'translateY(-20px)',
          fontSize: '14px',
          boxShadow: '0 4px 12px rgba(0,0,0,0.2)'
        });

        document.body.appendChild(toast);
        setTimeout(() => {
          toast.style.opacity = '1';
          toast.style.transform = 'translateY(0)';
        }, 10);

        setTimeout(() => {
          toast.style.opacity = '0';
          toast.style.transform = 'translateY(-20px)';
          setTimeout(() => toast.remove(), 300);
        }, 2000);
      }

      updateHeaderPrice() {
        fetch(`${window.routes.cart_url}.js`)
          .then(response => response.json())
          .then(cart => {
            // 1. Update Price
            const formattedPrice = (cart.total_price / 100).toLocaleString(undefined, {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2
            });
            const priceElements = document.querySelectorAll('.cart_total_price_dsio');
            priceElements.forEach(el => el.textContent = formattedPrice);

            // 2. Update Item Count
            const countElements = document.querySelectorAll('.cart-count-bubble');
            countElements.forEach(el => {
              // Update the text inside the bubble
              const countSpan = el.querySelector('span[data-cart-count]');
              if (countSpan) {
                countSpan.textContent = cart.item_count;
                countSpan.setAttribute('data-cart-count', cart.item_count);
              } else {
                // Fallback if the span isn't deep
                el.textContent = cart.item_count;
              }
              // Show bubble if it was hidden (empty cart)
              el.classList.remove('hidden');
            });
          })
          .catch(e => console.error('Error updating header:', e));
      }

      getMOQValue() {
        // Directly targeting the class as requested
        const moqElement = this.querySelector('.moqdsio, .promoq, .dsiomoqimp');
        
        if (moqElement) {
          parseInt(moqElement.getAttribute('data-moq'));
        }
        return 1; // Fallback if element or attribute is missing
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.submitButton.querySelector('.loading__spinner').classList.remove('hidden');

        // Sticky button loading state logic
        const productInfo = this.closest('product-info');
        const sectionId = productInfo?.dataset.section || productInfo?.dataset.originalSection;
        const stickyAddButton = sectionId ? document.getElementById(`StickyCart-ProductSubmitButton-${sectionId}`) : undefined;
        const stickyLoadingSpinner = stickyAddButton?.querySelector('.loading__spinner');
        if (stickyAddButton && stickyLoadingSpinner) {
          stickyAddButton.classList.add('loading');
          stickyLoadingSpinner.classList.remove('hidden');
        }

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);

        // Apply MOQ check from classes
        // const moq = this.getMOQValue();
        
       // 1. Find the MOQ element using your specific classes
        const moqElement = this.querySelector('.moqdsio, .promoq, .dsiomoqimp');
        
        // 2. Parse the value correctly from the data-moq attribute
        const moqValue = moqElement ? parseInt(moqElement.getAttribute('data-moq')) : 1;
        const currentQty = parseInt(formData.get('quantity')) || 1;

        // 3. Only override if the current quantity is less than the Minimum Required
        if (moqValue && currentQty < moqValue) {
          formData.set('quantity', moqValue);
          
          // Sync UI: Update the input field so the user sees the change
          const qtyInput = this.form.querySelector('input[name="quantity"]');
          if (qtyInput) {
            qtyInput.value = moqValue;
          }
          
          // Optional: Alert or Notification to inform the user
          alert(`Minimum order quantity for this item is ${moqValue}.`);
        }
        

        if (this.cart) {
          formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }

        const properties = document.querySelectorAll('.product-form__input [name^="properties"]');
        properties.forEach(property => {
          if (property.type === 'file') {
            if (!property.files || property.files.length === 0 || !property.files[0]) return;
            formData.append(property.name, property.files[0]);
            return;
          }
          if (property.value == null || property.value === '') return;
          formData.append(property.name, property.value);
        });

        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form-component',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } 

            // SUCCESS CASE - TRADITIONAL LOGIC
            this.showNotification('Item added Successfully');
            this.updateHeaderPrice();

            if (!this.cart) {
              // Only redirect if no drawer, with a slight delay for the message
              // setTimeout(() => { window.location = window.routes.cart_url; }, 1500);
              return;
            }

            if (!this.error) {
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form-component',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            }

            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener('modalClosed', () => {
                setTimeout(() => {
                  if (this.cart && typeof this.cart.renderContents === 'function') {
                    this.cart.renderContents(response);
                  }
                });
              }, { once: true });
              quickAddModal.hide(true);
            } else {
              if (this.cart && typeof this.cart.renderContents === 'function') {
                this.cart.renderContents(response);
              }
            }
          })
          .catch((e) => { console.error(e); })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.submitButton.querySelector('.loading__spinner').classList.add('hidden');

            if (stickyAddButton && stickyLoadingSpinner) {
              stickyAddButton.classList.remove('loading');
              stickyLoadingSpinner.classList.add('hidden');
            }
          });
      }
      toggleSubmitButton(disable = true, text) {
        if (!this.submitButton) return;

        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          this.submitButton.setAttribute('aria-disabled', 'true');
          if (text && this.submitButtonText) {
            this.submitButtonText.textContent = text;
          }
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButton.removeAttribute('aria-disabled');
          if (this.submitButtonText) {
            // It will fallback to 'Add to cart' if variantStrings isn't defined
            this.submitButtonText.textContent = window.variantStrings?.addToCart || 'Add to cart'; 
          }
        }
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;
        this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');
        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);
        if (errorMessage) this.errorMessage.textContent = errorMessage;
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}